<template>

    <form id="profile" v-on:submit="save">
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane active" id="activity">
                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-t">Personal Information</h5>
                            <hr />
                        </div> 
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>Title *</label>
                                <select class="form-control form-control-sm" required v-model="emp.SrName">
                                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                                    <option value="Mr.">Mr.</option>
                                    <option value="Mrs.">Mrs.</option>
                                    <option value="Ms.">Ms.</option>
                                    <option value="Engr.">Engr.</option>
                                    <option value="Dr.">Dr.</option>
                                    <option value="Prof.">Prof.</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>Full Name *</label>
                                <input class="form-control form-control-sm" id="name" v-model="emp.Name" required />
                            </div>
                        </div> 
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>Father Name *</label>
                                <input maxlength="60" v-model="emp.FatherName" class="form-control" required />
                            </div>
                        </div> 
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>CNIC *</label>
                                <!--<input pattern=".{15,}" required v-model="emp.CNIC" title="15 char required" min="15" maxlength="15" class="form-control" />-->
                                <!--<input class="form-control" required v-model="emp.CNIC"
                                       data-inputmask="'mask': ['99999-9999999-9']" data-mask>-->
                                <input class="form-control" type="text" v-mask="'#####-#######-#'" v-model="emp.CNIC" required title="15 characters required with dashes">
                            </div> 
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>Date of Birth *</label>
                                <input type="date" id="DOB" placeholder="dd-MMM-yyyy" required v-model="emp.DateOfBirth" class="form-control" />
                            </div>
                        </div>

                        <div class="col-lg-2 col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>Gender *</label>
                                <select class="form-control" required id="ddlGeder" v-model="emp.GenderID">
                                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                                    <option v-for="(item,index) in genders" v-bind:value="item.GenderID">{{item.Name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Image *</label>
                                <div>
                                    <input type="file" id="profileimg" v-on:change="onfileupload" v-bind:required="!img && !emp.Image">
                                </div>
                                <small>Max size is 500kb & Dimensions (200X200) </small>

                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Other Information</h5>
                            <hr />
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>Religion</label>
                                <select class="form-control" id="ddlReligion" v-model="emp.Detail.ReligionID">
                                    <option value="0" selected="selected">--Select--</option>
                                    <option v-bind:value="item.Name" v-for="(item,index) in religions" :value="item.ReligionID">{{item.Name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-2 col-md-3 col-sm-6">
                            <div class="form-group">
                                <label>Marital Status</label>
                                <select class="form-control " id="ddlMaritalStatus" v-model="emp.Detail.MaritalStatus">
                                    <option selected="selected" value="">--Select--</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divoced">Divoced</option>
                                    <option value="Widow">Widow</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-2 col-md-3 col-sm-6">
                            <div class="form-group">
                                <label>Blood Group</label>
                                <select class="form-control" v-model="emp.Detail.BloodGroup">
                                    <option value="">--Select--</option>
                                    <option value="A">A</option>
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B">B</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="O">O</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                    <option value="AB+">AB+</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>Nationality  </label>
                                <select class="form-control " id="ddlNationality" v-model="emp.Detail.NationalityID">
                                    <option value="0" selected="selected">--Select--</option>
                                    <option v-bind:value="item.Name" v-for="(item,index) in nationalities" :value="item.NationalityID">{{item.Name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>PEC No</label>
                                <input class="form-control" v-model="emp.Detail.PECNo" maxlength="20" />
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>NTC No</label>
                                <input class="form-control" v-model="emp.Detail.NTCNo" maxlength="30" />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <!-- /.tab-content -->
        </div>
        <div class="card-footer">

            <div class="float-right">
                <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
                <input type="submit" value="Save Profile" class="btn btn-success  " />
            </div>

        </div>
    </form>

</template>

<script>const axios = require('axios').default;

    export default ({
        props: {
            employeeId: Number,
            sendEmp: Function,
            sendImg: Function,
        },
        data() {
            return {
                genders: [],
                religions: [],
                nationalities: [],
                emp: {
                    EmployeeRegistrationID: 0,
                    OldEmpCode: '',
                    EmpCode: '',
                    SrName: 'Mr.',
                    Name: '',
                    FatherName: '',
                    GenderID: '',
                    DateOfBirth: '',
                    CNIC: '',
                    Detail: { BloodGroup: '', ReligionID: 1, NationalityID: 1, Nationality2: 0, MaritalStatus: '', PECNo: '', NTCNo: '' }
                },
                img: '',
                uid: 0,
                jid: 0
            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {
            pageLoad() {
                startReq();
                var vm = this;
                axios.get('/ApplicantsApi/pageLoadProfile?id=' + vm.employeeId)
                    .then(function (res) {

                        endReq();

                        if (!res.data.status) {
                            if (res.data.msg)
                                alert(res.data.msg);
                            if (res.data.redirect)
                                window.location.href = res.data.redirect;
                        }

                        vm.uid = res.data.uid;
                        vm.jid = res.data.jid;

                        vm.genders = res.data.genders;
                        vm.nationalities = res.data.nationalities;
                        vm.religions = res.data.religions;

                        if (res.data.emp) {
                            vm.emp = res.data.emp; 
                            vm.emp.Detail = res.data.emp.Detail ? res.data.emp.Detail : { BloodGroup: '', ReligionID: 1, NationalityID: 1, Nationality2: 0, MaritalStatus: '', PECNo: '', NTCNo: '' };
                            vm.sendEmp(res.data.shortDetail);
                            if (res.data.emp.Image)
                                vm.sendImg(res.data.emp.Image);
                        }

                        $('#name').focus();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            save(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/saveProfile?id=' + vm.employeeId + "&uid=" + vm.uid + "&jid=" + vm.jid, {
                    emp: vm.emp,
                    img: vm.img
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            vm.emp.EmployeeRegistrationID = res.data.shortDetail.id;
                            toastr.success("Saved Successfully", "Done");
                            vm.sendEmp(res.data.shortDetail);
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                //console.log(`${value}`);
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            checkFile(file) {
                if (file == null) {
                    return false;
                }

                if (file.size > 500000) {
                    toastr.error("file size is large maximum 500 kb allowed", "Error!");

                    return false;
                }

                if (file.type != "image/jpeg" && file.type != "image/png") {
                    toastr.error("Invalid File! only JPG and PNG is allowed");
                    return false;
                }

                return true;
            },

            onfileupload: function (event) {
                if (this.checkFile(event.target.files[0])) {
                    startReq();
                    var image = new Image;
                    var reader = new FileReader;
                    reader.onload = (e) => {
                        this.img = e.target.result
                        this.sendImg(this.img);
                    }
                    reader.readAsDataURL(event.target.files[0]);
                    endReq();
                }
                else {
                    $('#profileimg').val('');
                }
            },

            clear() {
                location.reload();
            }

        }
    })</script>

<style>
    .h4-t {
        margin-top: -9px;
        margin-bottom: -5px;
        font-weight: 600
    }

    .h4-c {
        margin-bottom: -5px;
        font-weight: 600
    }
</style>



// WEBPACK FOOTER //
// src/components/applicantProfile.vue